import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image, Button } from "react-bootstrap";
import { MESSAGE } from "../../../utils/message";
import Google_icon from "../../../assests/images/ls-page-image/google-icon.svg";
import facebook_icon from "../../../assests/images/ls-page-image/facebook-icon.svg";
import twitter_x_icon from "../../../assests/images/ls-page-image/twitter-x-icon.svg";
import {
    HaveAccountMain,
    HaveAccountTitle,
    HaveAccountIcon,
    HaveAccountText,
    LoginWithIcon,
} from "./alreadyAccount";
import { useLocation, useNavigate } from "react-router-dom";
import { socialLoginUserAction, socialLoginUserHandler } from "../../../redux/slices/auth/socialLogin-slice";
import { useDispatch, useSelector } from "react-redux";
import { openInNewTab } from "../../../utils/functions";
import { URLs } from "../../../utils/constant";

//import { LoginSocialFacebook, LoginSocialGoogle } from "reactjs-social-login";

const GOOGLE_CLIENT_ID = "116761776784-v2gpe1p5hjfkca6qimvkl8olkpqadnrp.apps.googleusercontent.com";  // Replace with your actual Google Client ID



const AlreadyHaveAccount = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch: any = useDispatch();
    const availableModules = useSelector((state: any) => state?.modules?.data?.results);
    const [SocialLogin, setSocialLogin] = useState<any>(null);
    const socialLoginRedux = useSelector((state: any) => state?.socialLogin);

    const getRedirectUri = () => {
        const currentUrl = window.location.origin;

        if (window.location.pathname.includes("/signin")) {
            return `${currentUrl}/signin`;
        } else if (window.location.pathname.includes("/signup")) {
            return `${currentUrl}/signup`;
        } else {
            return `${currentUrl}`; // Default redirect URI
        }
    };

    const handleGoogleLogin = () => {
        const redirectUri = getRedirectUri();
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=code&scope=openid profile email`;
        window.location.href = authUrl;
    };

    // const handleSocialLogin = (provider: string, data: any) => {

    //     const reqBody = {
    //         username: provider === 'facebook' ? `${data.first_name} ${data.last_name}` : data.name || '',
    //         email: data.email,
    //         provider: provider
    //     }
    //     dispatch(socialLoginUserHandler(reqBody));

    // }
    const handleSocialLogin = (provider: any, data: any) => {

        const reqBody = {
            username: data.name || '',
            email: data.email,
            provider: provider,
        };
        dispatch(socialLoginUserHandler(reqBody)); // Dispatch action to handle social login
    };

    useEffect(() => {
        if (socialLoginRedux?.data) {
            if (socialLoginRedux?.data?.status === 200 || socialLoginRedux?.data?.status === 202 || socialLoginRedux?.data?.status === 201)
                setTimeout(() => {
                    navigate("/");
                }, 500);
        }
    }, [socialLoginRedux])

    useEffect(() => {
        const redirectUri = getRedirectUri();
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');


        if (code) {

            fetch(`https://oauth2.googleapis.com/token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    code: code,
                    client_id: GOOGLE_CLIENT_ID,
                    client_secret: "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", // Replace with your client secret
                    redirect_uri: redirectUri,
                    grant_type: 'authorization_code',
                }),
            })
                .then((res) => res.json())
                .then((data) => {
                    // Use the returned token to fetch user data from Google
                    fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
                        headers: {
                            Authorization: `Bearer ${data.access_token}`,
                        },
                    })
                        .then((res) => res.json())
                        .then((userData) => {
                            handleSocialLogin('google', userData); // Handle the social login after fetching user data
                        });
                });
        }
    }, [navigate]);

    useEffect(() => {
        import('reactjs-social-login').then((module) => {
            setSocialLogin(module);
        });
    }, []);




    if (!SocialLogin) {
        return null; // Return null until the module is loaded
    }
    const { LoginSocialFacebook } = SocialLogin;

    return (
        <HaveAccountMain>
            {(availableModules?.google_login || availableModules?.facebook_login || availableModules?.twitter_login) && <HaveAccountTitle>{MESSAGE.orLoginWithText}</HaveAccountTitle>}
            <HaveAccountIcon>
                {/* {availableModules?.google_login && <LoginSocialGoogle
                    //client_id={"624739749229-4gpov528ts6c33elbdvdlk9nomee2djr.apps.googleusercontent.com"}
                    client_id={"116761776784-v2gpe1p5hjfkca6qimvkl8olkpqadnrp.apps.googleusercontent.com"}
                    scope="openid profile email"
                    discoveryDocs="claims_supported"
                    access_type="online"

                    onResolve={({
                        provider,
                        data,
                    }: {
                        provider: any;
                        data: any;
                    }) => {
                        handleSocialLogin(provider, data);
                    }}
                    onReject={(err: any) => {
                        console.log("Google login error:", err);
                    }}
                >
                    <LoginWithIcon>
                        <Button>
                            <Image src={Google_icon} alt="google icon" width="" height="" />
                        </Button>
                    </LoginWithIcon>
                </LoginSocialGoogle>} */}
                {availableModules?.google_login &&
                    <LoginWithIcon>
                        <Button onClick={handleGoogleLogin}>
                            <Image src={Google_icon} alt="google icon" width="" height="" />
                        </Button>
                    </LoginWithIcon>
                }




                {availableModules?.facebook_login && <LoginSocialFacebook
                    appId="775553144425143"

                    onResolve={({
                        provider,
                        data,
                    }: {
                        provider: any;
                        data: any;
                    }) => {
                        handleSocialLogin(provider, data);
                    }}

                    onReject={(error: any) => {
                        console.error("Facebook login error:", error);
                    }}
                    scope="email"
                >
                    <LoginWithIcon>
                        <Button>
                            <Image src={facebook_icon} alt="google icon" width="" height="" />
                        </Button>
                    </LoginWithIcon>
                </LoginSocialFacebook>}

                {availableModules?.twitter_login && <LoginWithIcon>
                    <Button onClick={() => openInNewTab(URLs.xURL)}>
                        <Image src={twitter_x_icon} alt="google icon" width="" height="" />
                    </Button>
                </LoginWithIcon>}

            </HaveAccountIcon>
            {availableModules?.user_registration && <HaveAccountText className={`${location.pathname === "/signin" ? 'login-text' : ''}`}>{MESSAGE.doNotHaveAccountText}<Button onClick={() => navigate("/signup")}>{MESSAGE.signUp}</Button></HaveAccountText>}
            {availableModules?.login && <HaveAccountText className={`${location.pathname === "/signup" ? 'sign-up-text' : ''}`}>{MESSAGE.alreadyHaveAccountText}<Button onClick={() => navigate("/signin")}>{MESSAGE.login}</Button></HaveAccountText>}
        </HaveAccountMain >
    );
};
export default AlreadyHaveAccount;

